import { render } from "./BlogContenido.vue?vue&type=template&id=6a1c6cf0"
import script from "./BlogContenido.vue?vue&type=script&lang=js"
export * from "./BlogContenido.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__